import { REDUCERS_NAME } from '../../constants';
import { createActionName } from '../../utility';

export const reducerName = REDUCERS_NAME.USER;

export const USER = createActionName(reducerName, 'USER');
export const USERS = createActionName(reducerName, 'USERS');
export const USERS_ROLE = createActionName(reducerName, 'USERS_ROLE');
